export const accessKeys = {
  homepage: '1',
  editMode: '2',
  publish: '3',
  dePublish: '4',
  delete: '5',
  search: '6',
  pal: '7',
  help: '0',
};
